import { BaseRestApiEndpoint, ERestApiMethod } from "utils/api";
import { TCity } from "../types";

type TInput = {
  city: TCity;
};

type TOutput = any;

export default class GetEmailingTobBoard extends BaseRestApiEndpoint<
  TInput,
  TOutput
> {
  method = ERestApiMethod.GET;
  resolveUri({ city }: TInput): string {
    // return "/fe-api/top-board/emailing?villageName=brno&setIsEmailing=true";
    return `/fe-api/top-board/emailing?villageName=${city}`;
  }
}
